import React, { useState } from "react";
import * as XLSX from "xlsx";
import Papa from "papaparse";

export default function ExportOptions({ data }) {
  const [showOptions, setShowOptions] = useState(false);

  const handleExportCSV = () => {
    const csv = Papa.unparse(data);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "fest_data.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    setShowOptions(false);
  };

  const handleExportExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
    XLSX.writeFile(workbook, "fest_data.xlsx");
    setShowOptions(false);
  };

  return (
    <div className="export-wrapper">
      <button
        onClick={() => setShowOptions(!showOptions)}
        className="export-toggle-btn"
      >
        Export Data
      </button>
      {showOptions && (
        <div className="export-popup">
          <p className="export-title">Download as:</p>
          <button onClick={handleExportCSV} className="export-option-btn">
            CSV
          </button>
          <button onClick={handleExportExcel} className="export-option-btn">
            Excel
          </button>
        </div>
      )}
    </div>
  );
}
